import { AutoPrepJobStatus } from 'types';
import { create } from 'zustand';

interface AutoPrepStatusStateStore {
  autoPrepStatus: AutoPrepJobStatus | '';
  setAutoPrepStatus: (status: AutoPrepJobStatus | '') => void;
}

export const useAutoPrepStatusStateStore = create<AutoPrepStatusStateStore>((set, get) => ({
  autoPrepStatus: '',

  setAutoPrepStatus: (status) =>
    set(() => ({
      autoPrepStatus: status,
    })),
}));
